module.exports = __webpack_public_path__ + "180a0634761ed7ca4e0b98224739fb8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meredicte/fomento_logo.png
// module id = 325
// module chunks = 1